import React from 'react';
import { t } from '../i18n';
import { useApp } from '../context/AppContext';

// Opens the conversation for a job, with an unread badge. Same button on the
// homeowner portal, the technician portal and the admin dashboard.
export default function MessageButton({ request, className = 'btn btn-outline btn-sm' }) {
  const { openThread, unreadCounts } = useApp();
  const unread = unreadCounts?.[request._id] || 0;
  return (
    <button className={className} onClick={(e) => { e.stopPropagation(); openThread(request); }}>
      {t('msg.open')}
      {unread > 0 && (
        <span style={{ marginLeft: 6, background: 'var(--red)', color: 'white', borderRadius: 50, fontSize: 10, padding: '1px 6px' }}>{unread}</span>
      )}
    </button>
  );
}
